import { Box, Checkbox, Typography } from "@material-ui/core";
import { memo } from "react";
import { ScheduleSelectItem } from "types/Schedule";
import { UserData } from "types/User";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { getUserScheduleHours } from "utils/scheduleHelpers";
import { ALL_ROLES } from "constants/constants";
import { SCHEDULE_DATE_COLUMN_IDS } from "./scheduleTable";
import { ScheduleDetails } from "./ScheduleDetails";
import { useDispatch } from "react-redux";
import { addOrRemoveIdFromSMSList } from "actions/scheduleActions";

interface ScheduleCellProps {
  columnId: string;
  userData: UserData;
  classes: any;
  currentUserRole: number;
  date?: string;
  idListForDelete: ScheduleSelectItem[];
  idListForSMS: number[];
}

const HoursCell = memo(({ userId, classes }: { userId: number; classes: any }) => {
  const hours = useTypeSelectors((state) =>
    getUserScheduleHours(
      state.scheduleTable.dataList,
      userId,
      state.scheduleTable.scheduleFilters.station,
    ),
  );

  return <Typography className={`${classes.tableCellContent} ${classes.tenuredCell}`}>{hours}</Typography>;
});

export const ScheduleCell = memo(
  ({ columnId, userData, classes, date, currentUserRole, idListForSMS, idListForDelete }: ScheduleCellProps) => {
    const dispatch = useDispatch();
    const userValue: any = userData[columnId as keyof UserData];

    if (SCHEDULE_DATE_COLUMN_IDS.has(columnId)) {
      return (
        <ScheduleDetails
          date={date}
          userData={userData}
          classes={classes}
          currentUserRole={currentUserRole}
          idListForDelete={idListForDelete}
        />
      );
    }

    switch (columnId) {
      case "checkbox":
        return (
          <Checkbox
            onChange={() => dispatch(addOrRemoveIdFromSMSList(userData.id))}
            checked={idListForSMS?.includes(userData.id)}
            className={classes.selectCheckbox}
          />
        );
      case "user":
        return (
          <Box className={classes.tableCellContent}>
          <Typography className={classes.textWrap}>
            {userData.first_name}
          </Typography>
          <Typography className={classes.textWrap}>
            {userData.last_name}
          </Typography>
          </Box>
        );
      case "badge":
        return <Typography className={classes.tableCellContent}>{userValue}</Typography>;
      case "role":
        return (
          <Typography className={classes.tableCellContent}>{ALL_ROLES[userValue - 1]}</Typography>
        );
      case "transporter_id":
        return (
          <Typography className={classes.tableCellContent}>{userData.transporter_id}</Typography>
        );
      case "tenured":
        return (
          <Box className={`${classes.tableCellContent} ${classes.tenuredCell}`}>
            {userValue >= 30 ? (
              <CheckCircleIcon className={classes.tenuredIcon} fontSize="small" />
            ) : (
              ""
            )}
            <Typography>{userValue}</Typography>
          </Box>
        );
      case "hours":
        return <HoursCell userId={userData.id} classes={classes} />;
      case "payroll":
        return <Typography className={classes.tableCellContent}>{userData.station_spots?.length ? userData.station_spots[0].agency.name : "---"}</Typography>
      default:
        return <Typography className={classes.tableCellContent}>---</Typography>;
    }
  },
);
